export default class FastScroll {
  bShowFastScroll = false;

  nWrapperHeight = 0;

  nInitPosY = 0;

  nInitPosTop = 0;

  bMoving = false;

  bAnimateScroll = false;

  constructor() {
    /* eslint-disable no-underscore-dangle */
    if (
      TMON.view_mode === 'app' &&
      TMON.app_os === 'ios' &&
      !TMON.app._isValidAppVersion('4.3.7')
    ) {
      return;
    }
    /* eslint-enable no-underscore-dangle */
    this.render();
    this.cacheElement();
    this.setWrapperPosition();
    this.checkSticky();
    this.setScrollerPosition();
  }

  cacheElement() {
    this.welScroller = $('#fastscroll [data-role=scrollModel]');
    this.welController = $('#fastscroll [data-role=controller]');
  }

  update() {
    this.checkSticky();
  }

  onScroll() {
    if (!this.bAnimateScroll && this.bShowFastScroll) {
      this.setScrollerPosition();
    }
  }

  /**
   * setEvent
   */
  setEvent() {
    // 이벤트가 겹치는 문제로 모웹에서 불필요한 마우스 이벤트는 제거. [SDLUI-1959] [FR-9830]
    // FastScroll 테스트는 개발자도구의 모웹을 이용하거나, 마우스 이벤트(mousedown, mousemove)를 임시로 붙여 해야함.
    this.welController.on('touchstart', () => {
      this.onTouchStart();
    });
    this.welController.on('touchend', () => {
      this.onTouchEnd();
    });
    this.welController.on('touchmove', e2 => {
      this.onTouchMove(e2);
    });
  }

  clearEvent() {
    this.welController.off('touchstart');
    this.welController.off('touchend');
    this.welController.off('touchmove', e2 => {
      this.onTouchMove(e2);
    });
  }

  onTouchStart() {
    this.bMoving = true;
  }

  onTouchMove(e) {
    e.preventDefault();
    e.stopPropagation();
    this.nWrapperHeight = $('#fastscroll').outerHeight();
    const nClientY =
      e.clientY !== undefined
        ? e.clientY - this.nWrapperTop
        : e.originalEvent.touches[0].clientY;
    let nPosY = nClientY - this.nWrapperTop;
    if (nPosY < 0) {
      nPosY = 0;
    } else if (nPosY > this.nWrapperHeight) {
      nPosY = this.nWrapperHeight;
    }
    const nPosYPercent = (nPosY * 100) / this.nWrapperHeight;
    if (
      this.nPervPosY === nPosY ||
      nClientY < 5 ||
      $(window).height() - nClientY < 5
    ) {
      return;
    }
    this.nPervPosY = nPosY;
    const nNewWindowScrollTop = parseInt(
      this.getScrollTopByPercent(nPosYPercent),
      10
    );
    TMON.oApp.oUtil.scrollTop(this, nNewWindowScrollTop);
  }

  onTouchEnd() {
    this.bMoving = false;
    this.setScrollerPosition();
  }

  getScrollTopByPercent(nPosYPercent) {
    const htRange = {
      min:
        $('#description').offset().top -
        this.nTabNavigationHeight -
        this.nHeaderHeight,
      max: $(document).height() - $(window).height(),
    };
    const nNewWindowScrollTop =
      ((htRange.max - htRange.min) * nPosYPercent) / 100 + htRange.min;
    return nNewWindowScrollTop;
  }

  setScroll(nPixel) {
    const nScrollStart =
      $('section[data-name=description]').offset().top -
      this.nHeaderHeight -
      this.nTabNavigationHeight;
    const nControllerPosPercent = (nPixel * 100) / this.nWrapperHeight;
    const nScrollEnd = $(document).height() - nScrollStart;
    let nScrollTop = (nScrollEnd * nControllerPosPercent) / 100;
    if (!nScrollTop) {
      nScrollTop = 0;
    }
    nScrollTop += nScrollStart;
    TMON.oApp.oUtil.scrollTop(this, nScrollTop);
  }

  getTranslateY = obj => {
    if (!window.getComputedStyle) {
      return false;
    }

    const style = getComputedStyle(obj);
    const transform =
      style.transform || style.webkitTransform || style.mozTransform;
    let mat = transform.match(/^matrix3d\((.+)\)$/);

    if (mat) {
      return parseFloat(mat[1].split(', ')[13]);
    }

    mat = transform.match(/^matrix\((.+)\)$/);

    return mat ? parseFloat(mat[1].split(', ')[5]) : 0;
  };

  checkSticky() {
    if (
      TMON.oApp.htStorage.tab === 'description' &&
      TMON.oApp.htStorage.sticky === 'tab-navigation'
    ) {
      if (!this.bShowFastScroll) {
        this.showFastScroll();
      }
    } else {
      this.hideFastScroll();
    }
  }

  setWrapperPosition() {
    this.nScrollerHeight = $('#fastscroll .scroller').outerHeight();
    this.nHeaderHeight = TMON.util.gup('headerHeight')
      ? parseInt(TMON.util.gup('headerHeight'), 10)
      : $('header:first').outerHeight();
    this.nTabNavigationHeight = $(
      '#tab-navigation .tab-inner:first'
    ).outerHeight();
    this.nWrapperTop = this.nHeaderHeight + this.nTabNavigationHeight;
    $('#fastscroll').css({
      top: this.nWrapperTop,
      bottom:
        parseInt($('#fastscroll').css('bottom'), 10) + this.nScrollerHeight,
    });
    this.nWrapperHeight = $('#fastscroll').outerHeight();
  }

  getScrollerPosition() {
    const nDocumentHeight = $(document).height() - $(window).height();
    const nScrollTop =
      $(window).scrollTop() - $('section[data-name=description]').offset().top;
    let nPercentValue = (nScrollTop * 100) / nDocumentHeight;
    if (nPercentValue < 0) {
      nPercentValue = 0;
    }
    if (nPercentValue > 100) {
      nPercentValue = 100;
    }

    const nValue = (this.nWrapperHeight * nPercentValue) / 100;
    return nValue;
  }

  setScrollerPosition() {
    const nValue = this.getScrollerPosition();
    this.welScroller.css({
      '-webkit-transform': `translateY(${nValue}px)`,
      '-moz-transform': `translateY(${nValue}px)`,
      '-ms-transform': `translateY(${nValue}px)`,
      '-o-transform': `translateY(${nValue}px)`,
      transform: `translateY(${nValue}px)`,
    });
    if (!this.bMoving) {
      this.welController.css({
        right: 0,
        '-webkit-transform': `translateY(${nValue}px)`,
        '-moz-transform': `translateY(${nValue}px)`,
        '-ms-transform': `translateY(${nValue}px)`,
        '-o-transform': `translateY(${nValue}px)`,
        transform: `translateY(${nValue}px)`,
      });
    }
  }

  showFastScroll() {
    $('#fastscroll').show();
    this.setEvent();
    this.setScrollerPosition();
    this.bShowFastScroll = true;
  }

  hideFastScroll() {
    $('#fastscroll').hide();
    this.clearEvent();
    this.bShowFastScroll = false;
  }

  /**
   * render
   */
  render() {
    const sHtml =
      '<div data-role="scrollModel" class="scroller"></div><div data-role="controller" class="scroller" style="background:none;padding:0 0 20px 20px"></div>';
    $('#fastscroll').html(sHtml);
  }
}
